module.exports = __webpack_public_path__ + "static/img/iconSearchQ.dea84a4.png";